export default {
  getConfigList() {
    return new Promise((resolve, reject) => {
      axios.get('/system/config')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getConfigApp() {
    return new Promise((resolve, reject) => {
      axios.get('/system/config-app')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getBbsList (params) {
    return new Promise((resolve, reject) => {
      axios.get('/data/bbs-list', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getBbsShow(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/bbs-info',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getCommentsList(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/comment-list',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getBbsType(){
    return new Promise((resolve, reject) => {
      axios.get('/data/bbs-type')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  changeBbsLabel(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/bbs-label-edit',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  changeCommentLabel(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/comment-label-edit',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getAllCommentsllist(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/comment-all-list',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  changecommentstips(params){
    return new Promise((resolve, reject) => {
      axios.post('/data/comment-all-label-edit',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getDowninfo(){
    return new Promise((resolve, reject) => {
      axios.get('/data/download')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getDown(params){
    return new Promise((resolve, reject) => {
      axios.post('/data/download-add',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getDownList(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/download-list',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getDownExcel(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/download-info',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getDownDel(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/download-delete',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getUserlist(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/list',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getUserInfo(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/info',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  setUserStop(params){
    return new Promise((resolve, reject) => {
      axios.post('/user/stop',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  editUser(params){
    return new Promise((resolve, reject) => {
      axios.post('/user/info-edit',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getVList(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/honor-list',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getCarUserlist(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/car-list',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getMessagelist(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/message',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  delMessage(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/message-del',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  
  getSysMessagelist(params){
    return new Promise((resolve, reject) => {
      axios.get('/notice/list',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  delSysMessage(params){
    return new Promise((resolve, reject) => {
      axios.get('/notice/del',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getMessageDownExcel(params){
    return new Promise((resolve, reject) => {
      axios.get('/group/wx-message-list-excel',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  changeUserPower(params){
    return new Promise((resolve, reject) => {
      axios.get('/user/power',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  changeUserPowerBrand(params){
    return new Promise((resolve, reject) => {
      axios.post('/user/power-brand',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getCode(params){
    return new Promise((resolve, reject) => {
      axios.post('/sms/code',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  Login(params){
    return new Promise((resolve, reject) => {
      axios.post('/user/login',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getWord(params){
    return new Promise((resolve, reject) => {
      axios.get('/data/bbs-words',{params:params})
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  Trainadd(params){
   return new Promise((resolve, reject) => {
    axios.post('/data/bbs-train-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
 },
 getTrainlist(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-train-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delTrain(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-train-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeUserBbstype(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/car-user-edit',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getActiveList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getConfig(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/config',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addActive(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editActive(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delActive(id){
  return new Promise((resolve, reject) => {
    axios.delete('/huodong-recruit/'+id+'/delete')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getActiveinfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLotteryList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/prize-luck',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLotteryExcel(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/prize-luck-excel',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLocationList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/clock-index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLocationinfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/clock-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addLocation(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/clock-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editLocation(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/clock-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delLocation(id){
  return new Promise((resolve, reject) => {
    axios.delete('/huodong-recruit/'+id+'/clock-delete')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getGiftList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/prize-index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getGiftinfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/prize-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addGift(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/prize-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editGift(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/prize-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delGift(id){
  return new Promise((resolve, reject) => {
    axios.delete('/huodong-recruit/'+id+'/prize-delete')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getZanLotteryList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/prize-user',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
setWinning(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/prize-user-select',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
setSort(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/prize-user-sort',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getSpeciallist(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-noun-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-brand-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addSpecial(params){
  return new Promise((resolve, reject) => {
    axios.post('/data/bbs-noun-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editSpecial(params){
  return new Promise((resolve, reject) => {
    axios.post('/data/bbs-noun-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delSpecial(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-noun-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
ActiveApproveList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/auth',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getActiveApproveinfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/auth-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
activeAudit(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/auth-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getStatList(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/count-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getArticleList(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
ArticleStatus(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/update-status',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getArticleLike(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/relevant',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCommentLike(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/relevant-comment',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
commentReply(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/relevant-comment-reply',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCommentReply(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/relevant-comment-reply-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
syncComment(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/relevant-comment-pull',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getTreeList(){
  return new Promise((resolve, reject) => {
    axios.get('/system/menu-index')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

addTree(params){
  return new Promise((resolve, reject) => {
    axios.post('/system/menu-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editTree(params){
  return new Promise((resolve, reject) => {
    axios.post('/system/menu-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delTree(params){
  return new Promise((resolve, reject) => {
    axios.post('/system/menu-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getGroupList(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addGroup(params){
  return new Promise((resolve, reject) => {
    axios.post('/group/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editGroup(params){
  return new Promise((resolve, reject) => {
    axios.post('/group/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delGroup(params){
  return new Promise((resolve, reject) => {
    axios.post('/group/del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getGroupSett(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/setting-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addGroupSett(params){
  return new Promise((resolve, reject) => {
    axios.post('/group/setting-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editGroupSett(params){
  return new Promise((resolve, reject) => {
    axios.post('/group/setting-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getAdminList(){
  return new Promise((resolve, reject) => {
    axios.get('/system/admin-index')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getAdminTreeList(params){
  return new Promise((resolve, reject) => {
    axios.get('/system/menu',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
adminMenu(params){
  return new Promise((resolve, reject) => {
    axios.post('/system/admin-menu',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

editAdminInfo(params){
  return new Promise((resolve, reject) => {
    axios.post('/system/admin-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getSourceList(){
  return new Promise((resolve, reject) => {
    axios.get('/source/info')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
saveSource(params){
  return new Promise((resolve, reject) => {
    axios.post('/source/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getVoteList(params){
  return new Promise((resolve, reject) => {
    axios.get('/surveyed/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addVote(params){
  return new Promise((resolve, reject) => {
    axios.post('/surveyed/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editVote(params){
  return new Promise((resolve, reject) => {
    axios.post('/surveyed/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delVote(params){
  return new Promise((resolve, reject) => {
    axios.post('/surveyed/del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQuesList(params){
  return new Promise((resolve, reject) => {
    axios.get('/surveyed/question-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addQues(params){
  return new Promise((resolve, reject) => {

    axios.post('/surveyed/question-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQuesInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/surveyed/question-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editQues(params){
  return new Promise((resolve, reject) => {
    axios.post('/surveyed/question-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delQues(params){
  return new Promise((resolve, reject) => {
    axios.post('/surveyed/question-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getToutUserlist(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/tt-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getWechatgrouplist(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/group-new',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getWechatuserlist(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/wx-contact-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
wechatusertype(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/wx-contact-type',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getWechatMessagelist(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/wx-message-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
wechatmessagetype(params){
  return new Promise((resolve, reject) => {
    axios.get('/group/wx-message-type',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLivelist(params){
  return new Promise((resolve, reject) => {
    axios.get('/live/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLiveInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/live/info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addLive(params){
  return new Promise((resolve, reject) => {
    axios.post('/live/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editLive(params){
  return new Promise((resolve, reject) => {
    axios.post('/live/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
statusLive(params){
  return new Promise((resolve, reject) => {
    axios.post('/live/status',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeLiveDel(params){
  return new Promise((resolve, reject) => {
    axios.post('/live/del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getLiveComment(params){
  return new Promise((resolve, reject) => {
    axios.get('/live/reply-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
liveCommentstatus(params){
  return new Promise((resolve, reject) => {
    axios.post('/live/reply-status',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
liveCommentdel(params){
  return new Promise((resolve, reject) => {
    axios.post('/live/reply-del-status',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getDataMonitorList(params){
  return new Promise((resolve, reject) => {
    axios.get('/count/index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getTargetlist(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/keyword',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addTarget(params){
  return new Promise((resolve, reject) => {
    axios.post('/third/keyword-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editTarget(params){
  return new Promise((resolve, reject) => {
    axios.post('/third/keyword-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delTarget(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/keyword-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getkeylist(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/keyword-content',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getGatherlist(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/collection',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addGather(params){
  return new Promise((resolve, reject) => {
    axios.post('/third/collection-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editGather(params){
  return new Promise((resolve, reject) => {
    axios.post('/third/collection-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delGather(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/collection-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getKeySearchList(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/task',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addKeySearch(params){
  return new Promise((resolve, reject) => {
    axios.post('/third/task-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getkeyUserlist(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/task-user',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getkeylistinfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/third/task-content',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterSource(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addMatterSource(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editMatterSource(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delMatterSource(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getMatterImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addMatterImg(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/img-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editMatterImg(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/img-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delMatterImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterMonitor(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/type-data',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getDownMatter(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/type-data-excel',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterTips(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/article-img',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
checkMatterTips(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/article-img-status',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMattersourceImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/library-img-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMattersourceArt(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/library-article-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterImgArt(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-article',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getCompanyList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/company-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCompany(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/company-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCompany(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/company-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCompany(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/company-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCompanyImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/company-img-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCompanyArt(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/company-article-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterDowninfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/download',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterDown(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/download-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterDownList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/download-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterDownExcel(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/download-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterDownDel(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/download-delete',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterArticle(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/template',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addMatterArticle(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/template-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editMatterArticle(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/template-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delMatterArticle(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/template-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterArticleArt(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/template-article',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMonitorBbsList(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-cate-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addMonitorBbs(params){
  return new Promise((resolve, reject) => {
    axios.post('/data/bbs-cate-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editMonitorBbs(params){
  return new Promise((resolve, reject) => {
    axios.post('/data/bbs-cate-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delMonitorBbs(params){
  return new Promise((resolve, reject) => {
    axios.get('/data/bbs-cate-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-status',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeMatterType(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-status-edit',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterTagList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-status-true',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeMatterTagType(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-status-edit-true',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeMatterTypeAdmin(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-status-edit-admin',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterListSearch(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

changeMatterSearchType(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/img-list-use-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeMatterLikeType(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-list-false-edit',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeMatterSourceType(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-list-library',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterMessage(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/img-list-library',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeUserImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/img-edit',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addUserCar(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/car-add',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editUserCar(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/car-edit',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delUserCar(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/car-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changePower(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/power-status',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getChannelList(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/power-status',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getUserTopInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/monitor/user-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getHonorMedal(params){
  return new Promise((resolve, reject) => {
    axios.get('/honor/all',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editHonorMedal(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addHonorMedal(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editHonorStatus(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/status',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getHonorList(params){
  return new Promise((resolve, reject) => {
    axios.get('/honor/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editHonor(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/honor-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addHonor(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/honor-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getHonorTasklist(params){
  return new Promise((resolve, reject) => {
    axios.get('/honor/reward-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editHonorTask(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/reward-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addHonorTask(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/reward-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getTasklist(params){
  return new Promise((resolve, reject) => {
    axios.get('/honor/task-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editTask(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/reward-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addTask(params){
  return new Promise((resolve, reject) => {
    axios.post('/honor/reward-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},


getPtArticleKeyword(params){
  return new Promise((resolve, reject) => {
    axios.get('/collection/keyword',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editPtArticleKeyword(params){
  return new Promise((resolve, reject) => {
    axios.post('/collection/keyword-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addPtArticleKeyword(params){
  return new Promise((resolve, reject) => {
    axios.post('/collection/keyword-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delPtArticleKeyword(params){
  return new Promise((resolve, reject) => {
    axios.get('/collection/keyword-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getPtArticleList(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/collection',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
setPtArticleSync(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/sync',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getPtArticleComment(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/collection-comment',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getAdvList(params){
  return new Promise((resolve, reject) => {
    axios.get('/adv/index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addAdv(params){
  return new Promise((resolve, reject) => {
    axios.post('/adv/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editAdv(params){
  return new Promise((resolve, reject) => {
    axios.post('/adv/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delAdv(params){
  return new Promise((resolve, reject) => {
    axios.get('/adv/del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarBrandList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/brand-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCarBrand(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/brand-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarBrand(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/brand-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCarBrand(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/brand-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarsList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/cars-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCars(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/cars-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCars(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/cars-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCars(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/cars-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarsEraList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/generation-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCarsEra(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/generation-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarsEra(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/generation-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCarsEra(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/generation-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getCarsModelList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/model-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCarsModel(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/model-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarsModel(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/model-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCarsModel(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/model-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarChannelList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/channel-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCarChannel(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/channel-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarChannel(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/channel-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCarChannel(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/channel-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarColumnList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/column-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCarColumn(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/column-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarColumn(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/column-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCarColumn(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/column-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getCarVideoList(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/video-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addCarVideo(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/video-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarVideo(params){
  return new Promise((resolve, reject) => {
    axios.post('/cars/video-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delCarVideo(params){
  return new Promise((resolve, reject) => {
    axios.get('/cars/video-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCarUserApprove(params){
  return new Promise((resolve, reject) => {
    axios.get('/user/owner',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCarUserApprove(params){
  return new Promise((resolve, reject) => {
    axios.post('/user/owner-audit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQaList(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addQa(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editQa(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delQa(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQaPhaseList(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/stage-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

addQaPhase(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/stage-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editQaPhase(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/stage-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delQaPhase(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/stage-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQaSeasonList(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/season-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addQaSeason(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/season-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editQaSeason(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/season-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
stopQaSeason(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/season-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQaquestList(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/question-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQaquestInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/question-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addQaquest(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/question-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editQaquest(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/question-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delQaquest(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/question-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getQaRecordList(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/record-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getRanking(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/ranking',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getWechatRanking(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/ranking-web-excel',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getSubaruDealersList(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/library',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addSubaruDealers(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/library-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editSubaruDealers(params){
  return new Promise((resolve, reject) => {
    axios.post('/subject/library-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delSubaruDealers(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/library-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getSubaruDealersMan(params){
  return new Promise((resolve, reject) => {
    axios.get('/subject/library-user',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getCompanyUserList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/company-user-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeCompanyUser(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/company-user-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getDmcMessageList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/company-msg-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addDmcMessage(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/company-msg-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getDmcTextList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/poster-text-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editDmcText(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/poster-text-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delDmcText(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/poster-text-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getDmcImgList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/poster-img-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editDmcImg(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/poster-img-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delDmcImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/poster-img-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getDmcSolarImgList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/solar-poster-img-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editDmcSolarImg(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/solar-poster-img-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delDmcSolarImg(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/solar-poster-img-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getMatterRedList(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/xhs-article-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editMatterRed(params){
  return new Promise((resolve, reject) => {
    axios.post('/library/xhs-article-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delMatterRed(params){
  return new Promise((resolve, reject) => {
    axios.get('/library/xhs-article-del',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getChatGptTypeList(params){
  return new Promise((resolve, reject) => {
    axios.get('/chat/channel',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addChatGptType(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/channel-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editChatGptType(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/channel-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editFormChatGptType(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/question-type',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getChatGptTypeChildList(params){
  return new Promise((resolve, reject) => {
    axios.get('/chat/column',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addChatGptChildType(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/column-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editChatGptChildType(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/column-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getChatgptList(params){
  return new Promise((resolve, reject) => {
    axios.get('/chat/question',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addChatGpt(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/question-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addEvent(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/event-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getChatGptInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/chat/event-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addChatGlm(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/question-glm-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getUserGroupList(params){
  return new Promise((resolve, reject) => {
    axios.get('/chat/group',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addUserGroup(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/group-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editUserGroup(params){
  return new Promise((resolve, reject) => {
    axios.post('/chat/group-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getVersionList(params){
  return new Promise((resolve, reject) => {
    axios.get('/version/index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addVersion(params){
  return new Promise((resolve, reject) => {
    axios.post('/version/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editVersion(params){
  return new Promise((resolve, reject) => {
    axios.post('/version/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delVersion(params){
  return new Promise((resolve, reject) => {
    axios.post('/version/del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getActiveProjectsList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/project-index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getActiveProjectsInfo(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/project-info',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addActiveProjects(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/project-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editActiveProjects(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/project-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delActiveProjects(id){
  return new Promise((resolve, reject) => {
    axios.delete('/huodong-recruit/'+id+'/project-delete')
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeUserMark(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/mark',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeBeiZhu(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/notes',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getHeadlinesList(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/headlines-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addHeadlines(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/headlines-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editHeadlines(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/headlines-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
showHeadlines(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/headlines-show',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delHeadlines(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/headlines-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getNewsList(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/news-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addNews(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/news-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editNews(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/news-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
showNews(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/news-show',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delNews(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/news-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getPositionList(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/position-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editPosition(params){
  return new Promise((resolve, reject) => {
    axios.post('/archive/position-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editPositionall(params){
  return new Promise((resolve, reject) => {
    axios.get('/archive/position-sync',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getPathList(params){
  return new Promise((resolve, reject) => {
    axios.get('/appmsg/path-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addPath(params){
  return new Promise((resolve, reject) => {
    axios.post('/appmsg/path-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editPath(params){
  return new Promise((resolve, reject) => {
    axios.post('/appmsg/path-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delPath(params){
  return new Promise((resolve, reject) => {
    axios.post('/appmsg/path-del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getAppMessageList(params){
  return new Promise((resolve, reject) => {
    axios.get('/appmsg/msg-list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addAppMessage(params){
  return new Promise((resolve, reject) => {
    axios.post('/appmsg/msg-add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editAppMessage(params){
  return new Promise((resolve, reject) => {
    axios.post('/appmsg/msg-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getCicloreIndexList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/ciclore-index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editCiclore(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/ciclore-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getStiApproveList(params){
  return new Promise((resolve, reject) => {
    axios.get('/huodong-recruit/sti-index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editStiApprove(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/sti-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},

getAgreementList(params){
  return new Promise((resolve, reject) => {
    axios.get('/agreement/index',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addAgreement(params){
  return new Promise((resolve, reject) => {
    axios.post('/agreement/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editAgreement(params){
  return new Promise((resolve, reject) => {
    axios.post('/agreement/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
changeSendStatus(params){
  return new Promise((resolve, reject) => {
    axios.post('/huodong-recruit/ciclore-send-edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
addDeviceMac(params){
  return new Promise((resolve, reject) => {
    axios.post('/device/add',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
editDeviceMac(params){
  return new Promise((resolve, reject) => {
    axios.post('/device/edit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getDeviceMacList(params){
  return new Promise((resolve, reject) => {
    axios.get('/device/index',{
      params:params
    })
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
delDeviceMac(params){
  return new Promise((resolve, reject) => {
    axios.post('/device/del',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
getOnlineActivityList(params){
  return new Promise((resolve, reject) => {
    axios.get('/online-activity/list',{params:params})
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},
onlineActivityAudit(params){
  return new Promise((resolve, reject) => {
    axios.post('/online-activity/audit',params)
    .then((response) => {
      resolve(response)
    })
  }, err => {
    reject(err)
  })
},


}


// WEBPACK FOOTER //
// ./src/api/port.js